import React, { useContext, useEffect, useMemo, useState } from "react";
import { PDFDesignerProviderValue, PhoenixPDFsDesignerContext } from "./PhoenixPdfDesignerContext";
import { Button } from "components/Shared";
import ReorderableGrid, { ReorderableItem } from "components/Shared/ReorderableGrid";
import PhoenixPdfDesignerSection from "./PhoenixPdfDesigerSection";

const reorderSectionHandle = "reorder-section-handle";

const PhoenixPdfDesignerPreview = () => {
  let context = useContext<PDFDesignerProviderValue>(PhoenixPDFsDesignerContext);

  const sections = context.pdfDefinition.displayControls;

  const [sectionCollapseStatus, _setSectionCollapseStatus] = useState<boolean[]>(() => sections.map(_ => false));

  useEffect(() => {
    // if we add a new section, update the sections collapse list
    if (context.lastChangeType === "add section" || context.lastChangeType === "delete children") {
      let newSections = [...sectionCollapseStatus];
      console.log("last change data " + context.lastChangeData);
      if (context.lastChangeType === "add section") newSections.splice(context.lastChangeData as number + 1, 0, false);
      if (context.lastChangeType === "delete children") newSections.splice(context.lastChangeData as number, 1);
      _setSectionCollapseStatus(newSections);
    }
  }, [context.pdfDefinitionUpdatedAt]);

  const setCollapseStatus = (sectionIndex: number, newValue: boolean) => {
    let newStatus = [...sectionCollapseStatus];
    newStatus[sectionIndex] = newValue;
    _setSectionCollapseStatus(newStatus);
  };

  const setAllCollapseStatus = (newValue: boolean) => {
    let newStatus = [...sectionCollapseStatus];
    sections.forEach((_, i) => newStatus[i] = newValue);
    _setSectionCollapseStatus(newStatus);
  };

  const areAllCollapsed = !sectionCollapseStatus.some(s => !s);

  const controls = useMemo<ReorderableItem[]>(
    () => sections.map((s, i) => ({
      id: `${i}`,
      node: (
        <PhoenixPdfDesignerSection
          key={s.name}
          element={s}
          elementIndex={i}
          isCollapsed={sectionCollapseStatus[i]}
          setCollapsed={val => setCollapseStatus(i, val)}
          setAllCollapsed={setAllCollapseStatus}
          areAllCollapsed={areAllCollapsed}
        />
      ),
    })),
    [context.pdfDefinitionUpdatedAt, sectionCollapseStatus]);

  return (
    <div className="phoenixform-designer-preview">
      <ReorderableGrid
        className="reorderable-sections"
        items={controls}
        handleSelector={`.${reorderSectionHandle}`}
        onReorder={ids => context.editFns.reorderChildren(null, ids.map(i => (i)))}
      />
      {/* Button outside of sections to allow for a new section when they are all collapsed */}
      {(!sectionCollapseStatus.length || sectionCollapseStatus[sections.length - 1]) && (
        <div className="bottom-new-section-button">
          <Button
            primary
            onClick={() => context.editFns.addNewSection(sections.length - 1)}
          >
            Add New Section
          </Button>
        </div>
      )}
    </div>
  );
};

export default PhoenixPdfDesignerPreview;
